export const URI = process.env.REACT_APP_URL || 'https://dev.adminexpertus.expertus.com.ua';
export const CDN_URL = process.env.CDN_URL || 'https://images.expertus.com.ua';
export const API_URL = URI.trim() + '/api';
export const drawerWidth = 280;
export const TOKEN = {
  access: 'YWNjZXNzLXRva2Vu',
  refresh: 'cmVmcmVzaC10b2tlbg',
};
export const HOTJAR_ID = process.env.REACT_APP_HOTJAR_KEY;

console.log("url", URI);

export const configSites: { [x: number]: { url: string } } = {
  1: {
    url: process.env.REACT_APP_URL_GB || 'https://dev.1glexpertus.expertus.com.ua',
  },
  2: {
    url: process.env.REACT_APP_URL_OP || 'https://dev.1opexpertus.expertus.com.ua',
  },
  3: {
    url: process.env.REACT_APP_URL_EK || 'https://dev.1kexpertus.expertus.com.ua',
  },
  4: {
    url: process.env.REACT_APP_URL_DZ || 'https://dev.1dzexpertus.expertus.com.ua',
  },
  5: {
    url: process.env.REACT_APP_URL_MED || 'https://dev.1medexpertus.expertus.com.ua',
  },
};
